// extracted by mini-css-extract-plugin
export default {"modalContent":"index_modalContent__sThCm","icon":"index_icon__AbAx9"};